import ViewAsDescription from './ViewAsDescription';

export default ViewAsDescription;
